import $ from 'jquery';

export const traverseFn = (highlightClass = 'chem-current-highlight') => ({ ele }) => {
    if (traverseFn.last) {
        traverseFn.last.classList.remove(highlightClass);
    }
    ele.classList.add(highlightClass);
    traverseFn.last = ele;
};

let style;

export const updateElementsStyleBySelector = (selector) => {
    if (!style) {
        style = document.createElement('style');
        style.type = 'text/css';
        document.head.appendChild(style);
    }
    style.innerHTML = `
    ${selector} {
        background-color: #FFF98A !important;
    }
    `;
};

export const deleteElementsStyleBySelector = () => {
    if (style) {
        style.remove();
        style = null;
    }
};

function traverse(selector, options) {
    let step = 1;
    let { start, fn } = options || {};
    start = start || 0;
    fn = fn || traverseFn();

    updateElementsStyleBySelector(selector);

    function * iterator(selector) {
        const array = $(`${selector}:visible`);
        const size = array.length;
        while (size > 0) {
            const data = {
                ele: array[start],
                index: start,
                array,
            };
            try {
                fn(data);
            } catch (e) {
                // 确保 fn 执行错误，也不打断
                console.warn(e);
            }
            yield data;
            start = (start + step) % size;
            if (start < 0) {
                start = size - 1;
            }
        }
    }

    const it = iterator(selector);
    return {
        next(next = true) {
            step = next ? 1 : -1;
            return it.next().value;
        },
        delete(highlightClass) {
            traverseFn.last.classList.remove(highlightClass);
        }
    };
}

export default traverse;
